import { StyleSheet } from 'react-native';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  modal: {
    width: 341,
    padding: 'auto',
    borderRadius: CornerRadius.Huge,
  },
  content: {
    paddingVertical: 16,
    paddingHorizontal: 24,
    gap: 6,
  },
  option: {
    paddingVertical: 12,
  },
  text: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
});
